import { mergeAttributes, Node } from '@tiptap/core'

import StepperDescription from './StepperDescription'
import StepperList from './StepperList'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    steps: {
      insertSteps: () => ReturnType
    }
  }
}

export const Stepper = Node.create({
  name: 'stepper',

  group: 'block',

  content: 'stepperList stepperDescription',

  addExtensions() {
    return [StepperList, StepperDescription]
  },

  addOptions() {
    return {
      HTMLAttributes: {
        class: `node-${this.name}`,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: `table[data-type="${this.name}"]`,
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'table', mergeAttributes(HTMLAttributes, { 'data-type': this.name, class: 'stepper', bgColor: '#F4F4F3' }), [
        'tr', {}, [
          'td', {}, [
            'table', {}, [
              'tr', {}, 0
            ]
          ]
        ]
      ],
    ]
  },

  addCommands() {
    return {
      insertSteps:
        () =>
          ({ state, chain }) => {
            const position = state.selection.$from.start()
            const selectionContent = state.selection.content()

            return chain()
              .insertContent({
                type: this.name,
                content: [
                  {
                    type: 'stepperList',
                    content: [
                      {
                        type: 'stepperItem',
                      },
                    ],
                  },
                  {
                    type: 'stepperDescription',
                    content: selectionContent.content.toJSON() || [
                      {
                        type: 'paragraph',
                        attrs: {
                          textAlign: 'left',
                        },
                      },
                    ],
                  },
                ],
              })
              .focus(position)
              .updateStepperItemPositions()
              .run()
          },
    }
  },
})

export default Stepper
